/* Creazione dei Marker su mappa attivati dopo aver cercato nelle search bar */
import { useLeaflet } from "react-leaflet";
import { connect } from "react-redux";
import { useEffect } from "react";
import L from "leaflet";
import i18n from 'i18next';
import startFlag from './start.png'
import finishFlag from './finish.png'
import createDiv from '../ClickOnMap/CreateDiv';
import { changepositionStart,changepositionEnd,selectNewMarkerStart2, selectNewMarkerEnd2,changeNomeFermataStart,changeNomeFermataEnd, changePercorsoDrawer,changePercorsoTariffa,changePositionTariffaStart,changePositionTariffaEnd, changePolyReal,changeLineaRealTime,changeAziendaRealTime,changeRegioneAereoPartenza,changeRegioneAereoArrivo, changeLayerDrawer, changeLayerInformation,changeLayerDiv, changeArrayLayer, changeLatLongLayer,changeMappa} from "../../redux";


// import CircularProgress from '@material-ui/core/CircularProgress';
import popupImg from './popup.svg'

const icon = L.icon({
  iconUrl: popupImg,
  iconSize:     [30, 40],
  iconAnchor:   [15  , 35],
  popupAnchor:  [0, -35]
});  

const DrawMarker = (props) => {
    const { map } = useLeaflet();
    const drawImage = (image) => {
        var iconStart = L.icon({
          iconUrl: image,
          iconSize: [30, 30],
          iconAnchor:   [15  , 35],
          popupAnchor:  [0, -35]
        });
    return iconStart
}

//Rimozione Layer
const removeOldLayer = (string) => {
    map.eachLayer(element => {
      if ( element.options.nome === string ) {
        try {
          element.removeFrom(map) 
        }
        catch(e) { 
        }
      }
    });
  }

    useEffect(()=>{
      try {  
        if(props.markerStart.markerStart){
          removeOldLayer("markerStart")
          const start = [props.markerStart.markerStart.lat,props.markerStart.markerStart.lng]
          
          const startMarker = L.marker(start,{icon: drawImage(startFlag),nome: "markerStart"})
          startMarker.addTo(map)          
          
          map.fitBounds([start,start], {maxZoom: 15});
        }
      } catch (error) {
          
      }
    },[props.markerStart])

    useEffect(()=>{
      try { 
        if(props.markerEnd.markerEnd){
            removeOldLayer("markerEnd")
            const end = [props.markerEnd.markerEnd.lat,props.markerEnd.markerEnd.lng]
            const endMarker = L.marker(end,{icon: drawImage(finishFlag),nome: "markerEnd"})
            endMarker.addTo(map)
            
            map.fitBounds([end,end], {maxZoom: 15});
        }
      } catch (error){}
    },[props.markerEnd])

    useEffect(()=>{
      try { 
        if(props.cercaFermata.cercaFermata && props.cercaFermata.cercaFermata.lat && props.cercaFermata.cercaFermata.lng){
          let cercaFermata = props.cercaFermata.cercaFermata
          let data = {stop_id: cercaFermata.id, stop_comune: cercaFermata.comune, stop_lat: cercaFermata.lat, stop_lon: cercaFermata.lng, stop_display_name: cercaFermata.description, stop_name: cercaFermata.description, stop_type: cercaFermata.type}
          //let layer = [{nome: cercaFermata.type, url_service: "/geoserver/sardegna/wms?", info: {features: [{properties:data}]}}]
          let layer = [{nome: cercaFermata.type, url_service: window.configFile.httpProxy.urlGeoserver+"?", info: {features: [{properties:data}]}}]
          //let container = L.DomUtil.create('div','custom')
          let latlng = {lat: cercaFermata.lat, lng: cercaFermata.lng}
          let container = createDiv(layer,latlng, props, map)
          props.changeArrayLayer(layer)
          
          L.marker(latlng,{icon:icon, nome: "position", closeOnClick: false, autoClose: false})
          .addTo(map)
          .bindPopup(container)
          .openPopup()   
        
          map.fitBounds([latlng,latlng], {maxZoom: 15}); 
          //if(window.innerWidth<600 && cercaFermata) document.querySelector("#drawer_id .buttonClose")[0].click()
        }
   } catch (error){
      console.log(error)
   }
  },[props.cercaFermata])
    return null;
}

const mapStateToProps = state => {
    return {
        markerStart: state.markerStart,
        markerEnd: state.markerEnd,
        cercaFermata: state.cercaFermata        
    }
  }
  
  const mapDispatchToProps = dispatch => {
    return {
        
      changepositionStart: (positionStart) => dispatch(changepositionStart(positionStart)),
      changepositionEnd: (positionEnd) => dispatch(changepositionEnd(positionEnd)),
      markerStart2: (marker) => dispatch(selectNewMarkerStart2(marker)),
      markerEnd2: (marker) => dispatch(selectNewMarkerEnd2(marker)),
      changeNomeFermataStart :(nomeFermataStart) => dispatch(changeNomeFermataStart(nomeFermataStart)),
      changeNomeFermataEnd :(nomeFermataEnd) => dispatch(changeNomeFermataEnd(nomeFermataEnd)),
      changePercorsoDrawer : (percorsoDrawer) => dispatch(changePercorsoDrawer(percorsoDrawer)),
      changePercorsoTariffa : (percorsoTariffa) => dispatch(changePercorsoTariffa(percorsoTariffa)),
      changePositionTariffaStart : (positionTariffaStart) => dispatch(changePositionTariffaStart(positionTariffaStart)),
      changePositionTariffaEnd : (positionTariffaEnd) => dispatch(changePositionTariffaEnd(positionTariffaEnd)),
      changePolyReal : (polyReal) => dispatch(changePolyReal(polyReal)),
      changeAziendaRealTime: (aziendaRealTime) => dispatch(changeAziendaRealTime(aziendaRealTime)),
      changeLineaRealTime: (lineaRealTime) => dispatch(changeLineaRealTime(lineaRealTime)),
      changeRegioneAereoPartenza : (regioneAereoPartenza) => dispatch(changeRegioneAereoPartenza(regioneAereoPartenza)),
      changeRegioneAereoArrivo : (regioneAereoArrivo) => dispatch(changeRegioneAereoArrivo(regioneAereoArrivo)),
      changeLayerDrawer : (layerDrawer) => dispatch(changeLayerDrawer(layerDrawer)),
      changeLayerInformation : (layerInformation) => dispatch(changeLayerInformation(layerInformation)),
      changeLayerDiv : (layerDiv) => dispatch(changeLayerDiv(layerDiv)),
      changeArrayLayer : (arrayLayer) => dispatch(changeArrayLayer(arrayLayer)),
      changeLatLongLayer : (latLongLayer) => dispatch(changeLatLongLayer(latLongLayer)),
      changeMappa : (mappa) => dispatch(changeMappa(mappa))

    }
  }
export default connect(mapStateToProps,mapDispatchToProps)(DrawMarker);